import { clone } from '@jack-henry/frontend-utils/functions';
import { formatUsdCurrency } from '@treasury/utils';
import { format } from 'date-fns';

interface BalanceReportDto {
    accountNumber: string;
    accountName: string;
    accountType: string;
    currentBalance: number;
    availableBalance: number;
    collectedBalance: number;
    data?: DateRangeBalanceReportItem[];
}

const nullBalanceReportItem: BalanceReportDto = {
    accountNumber: '',
    accountName: '',
    accountType: '',
    currentBalance: 0,
    availableBalance: 0,
    collectedBalance: 0,
};

export type DateRangeBalanceReportItem = {
    date: string;
    openingBalance: number;
    collectedBalance: number;
    debits: number | null;
    debitCount: number | null;
    credits: number | null;
    creditCount: number | null;
};

export class BalanceReportItemVm {
    constructor(private dto = clone(nullBalanceReportItem)) {}

    public createDefault() {
        return new BalanceReportItemVm(this.dto);
    }

    public get isTransaction() {
        return false;
    }

    public get accountNumber() {
        return this.dto.accountNumber;
    }

    public get accountName() {
        return this.dto.accountName;
    }

    public get accountType() {
        return this.dto.accountType;
    }

    public get currentBalance() {
        return formatUsdCurrency(this.dto.currentBalance);
    }

    public get availableBalance() {
        return formatUsdCurrency(this.dto.availableBalance);
    }

    public get collectedBalance() {
        return formatUsdCurrency(this.dto.collectedBalance);
    }

    public get data() {
        return this.dto.data?.map(item => ({
            date: format(new Date(item.date), 'P'),
            openingBalance: formatUsdCurrency(item.openingBalance),
            collectedBalance: formatUsdCurrency(item.collectedBalance),
            // eslint-disable-next-line no-restricted-syntax
            debits: item.debits ? formatUsdCurrency(item.debits) : null,
            debitCount: item.debitCount,
            // eslint-disable-next-line no-restricted-syntax
            credits: item.credits ? formatUsdCurrency(item.credits) : null,
            creditCount: item.creditCount,
        }));
    }

    public get isDateRange() {
        return !!this.dto.data;
    }
}
